import { getToken } from '@/api'

export default {
    login (username, password)
    {

    },
    getToken() {
        return localStorage.token
    },
    logout() {
        delete localStorage.token
        delete localStorage.organizationName
        delete localStorage.organizationId
    },
    loggedIn() {
        return !!localStorage.token
    },
    getUserName(){
        return localStorage.username;
    },
    getOrganizationName(){
        return localStorage.organizationName;
    },
    getOrganizationId(){
        return localStorage.organizationId;
    }
}


// WEBPACK FOOTER //
// ./src/api/auth-helper.js